import { ERROR_TITLES } from "../constants/messages/errors.js";

// For quickly accessing query params & preparing for requests.
export const prepareQueryParams = (extraParams = {}) => {
  const { q: quotenumber, co: coid, dealId } = getQueryParams();

  const shouldAddDates =
    window.location.pathname.startsWith("/owners") &&
    !window.location.pathname.includes("checkout");

  return {
    quotenumber,
    coid,
    ...(dealId && { dealId }),
    ...(shouldAddDates && {
      checkin_date:
        sessionStorage.getItem(`checkinDate${quotenumber}${coid}`) || undefined,
      checkout_date:
        sessionStorage.getItem(`checkoutDate${quotenumber}${coid}`) ||
        undefined,
    }),
    ...extraParams,
  };
};

export const getQueryParams = () => {
  const queryString = window.location.search;
  const search = new URLSearchParams(queryString);

  return Object.fromEntries(search.entries());
};

// For forms
export const splitName = (str = "") => {
  let firstName = "";
  let lastName = "";

  if (!str) return ["", ""];

  const nameArray = str.trim().split(" ");

  if (nameArray.length > 2) {
    firstName = `${nameArray[0]} ${nameArray[1]}`;
    lastName = nameArray[nameArray.length - 1];
  } else {
    firstName = nameArray[0];
    lastName = nameArray[1];
  }

  return [firstName, lastName];
};

// For building FormData payloads
export const toFormData = (data = {}) => {
  const formData = new FormData();

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      formData.append(key, data[key]);
    }
  }

  return formData;
};

export const getErrorMessage = (error = {}) => {
  let title = "Error";
  let message = "An unexpected error occurred.";

  if (error) {
    const { Errors, Message } = error;

    if (Errors && Object.keys(Errors)?.length > 0) {
      const firstErrorKey = Object.keys(Errors)[0];

      title = ERROR_TITLES[firstErrorKey] || firstErrorKey || "Error";
      message = Errors[firstErrorKey][0] || message;
    } else if (Message) {
      message = Message;
    }
  }

  return { title, message };
};
